import { z } from 'zod';
import { channelSchema } from './index';

// Export the schema from index
export { channelSchema };
export type ChannelFormData = z.infer<typeof channelSchema>;

// Define the schema for bulk updating channels
export const channelBulkUpdateSchema = z.object({
  category_id: z.number().nullable().optional(),
  category_ids: z.array(z.number()).optional(),
  default_category_id: z.number().nullable().optional(),
  categoryUpdateMode: z.enum(['add', 'replace', 'remove']).optional(),
  plan_ids: z.array(z.number()).optional(),
  channelIds: z.array(z.number()).min(1, 'Select at least one channel'),
  description: z.string().optional(),
  price: z.number().nullable().optional() // Make consistent with channelSchema
}); 